import * as R from 'ramda'
import * as React from 'react'
import * as ThemeUi from 'theme-ui'

import PropTypes from 'prop-types'

/**
 * Component used for FieldBuilder, to be able to generate custom UI-schemas
 * @component Box
 * @param {Object} props Components props
 * @param {ReactNode} props.children A component to be wrapped by Box
 * @param {*=} props.* Any valid style-in-js prop @see {@link https://theme-ui.com/guides/object-styles}
 * @returns {ReactNode} Component that wraps children
 */
export function Box(props) {
  return (
    <ThemeUi.Box
      sx={{
        ...R.omit(['children'], props),
      }}
    >
      {props.children}
    </ThemeUi.Box>
  )
}

Box.propTypes = {
  children: PropTypes.node,
}
